import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultWorkflowRepresentationResource,
    useWorkflowRepresentationActions,
    WorkflowRepresentationMutationResourceSchema,
} from '../../../../../resource/resources/artifacts/use_case/representation/workflowRepresentationResource';
import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import React from 'react';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import {
    Form_DisplayComponentBaseView,
} from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { WorkflowRepresentationContent } from './WorkflowRepresentationContent';

export const WorkflowRepresentationEditDialog= ({ onClose, objectId, versionedInId }: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
    projectId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const workflowRepresentationActions = useWorkflowRepresentationActions()
    const workflowRepresentationQuery = workflowRepresentationActions.useGetResourceByObjectIdAndVersionedIn(
        objectId,
        versionedInId,
    );
    const updateWorkflowRepresentation = workflowRepresentationActions.useUpdateResource();
    const validation = workflowRepresentationActions.useValidateResource(
        workflowRepresentationQuery.data?.id,
        validationScope,
    );

    const { form, formNames, onSubmit } = useMyForm({
        schema: WorkflowRepresentationMutationResourceSchema,
        defaultValues: defaultWorkflowRepresentationResource,
        submitHandler: async (data) => {
            await updateWorkflowRepresentation.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: workflowRepresentationQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Workflow Representation'}
            resourceType={ResourceType.WORKFLOW_REPRESENTATION}
            resourceValidationResult={validation.data}
            metaDataInfo={workflowRepresentationQuery.data}
        >
            <QueryBaseComponent name="WorkflowRepresentation" query={workflowRepresentationQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <WorkflowRepresentationContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={workflowRepresentationQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
